import { BaseStore } from "@infrastructure/stores/_base.store";
import type { OrderStatusConfigItem } from "@infrastructure/clients/http/clients/order.client";

type OrderStatusConfigState = {
  statuses: OrderStatusConfigItem[];
  loaded: boolean;
};

export const DEFAULT_STATUSES: OrderStatusConfigItem[] = [
  { status: "created", label: "Заказ создан", icon: "history" },
  { status: "waiting_for_payment", label: "Ожидает оплаты", icon: "history" },
  { status: "processing", label: "Обработка", icon: "history" },
  { status: "printing", label: "Идет печать", icon: "history" },
  { status: "ready", label: "Заказ готов", icon: "check" },
  { status: "issued", label: "Заказ выдан", icon: "x" },
  { status: "completed", label: "Заказ завершен", icon: "check" },
  { status: "canceled", label: "Заказ отменен", icon: "x" },
  { status: "error", label: "Ошибка при выполнении заказа", icon: "x" },
];

class OrderStatusConfigStoreFactory extends BaseStore<OrderStatusConfigState> {
  private _statuses: OrderStatusConfigItem[] = [...DEFAULT_STATUSES];
  private _loaded = false;

  protected createState(): OrderStatusConfigState {
    return {
      statuses: this._statuses,
      loaded: this._loaded,
    };
  }

  protected getStateKey(): string {
    return `orderStatuses:${this._statuses.length}:${this._loaded}`;
  }

  setStatuses(statuses: OrderStatusConfigItem[]): void {
    this._statuses = statuses;
    this._loaded = true;
    this.notifyListeners();
  }

  getByStatus(status: string): OrderStatusConfigItem | undefined {
    return this._statuses.find((s) => s.status === status);
  }

  getLabel(status: string): string {
    return this.getByStatus(status)?.label ?? status;
  }

  getIcon(status: string): string {
    return this.getByStatus(status)?.icon ?? "history";
  }
}

export const OrderStatusConfigStore = new OrderStatusConfigStoreFactory();
